(() => {
  if (customElements.get('bc-service-page')) return;
  class ServicePage extends HTMLElement {
    connectedCallback() {
      if(this.abort) return;
      this.abort = new AbortController(); this.timers = [];
      const signal = this.abort.signal;
      // Keep the scope concise while retaining every native row/detail disclosure.
      this.scopeAnimations = [];
      this.querySelectorAll('[data-scope-toggle]').forEach(button => {
        const board = button.closest('[data-scope-board]');
        const extra = this.querySelector('#' + CSS.escape(button.getAttribute('aria-controls')));
        if (!extra) return;
        const reveals = [...extra.querySelectorAll('.bc-scope__reveal')];
        let desired = false, revision = 0;
        extra.hidden = true; extra.inert = true; button.hidden = false;
        button.setAttribute('aria-expanded', 'false');
        button.addEventListener('click', async () => {
          desired = !desired; const currentRevision = ++revision;
          const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
          const heights = reveals.map(el => extra.hidden ? 0 : el.getBoundingClientRect().height);
          reveals.forEach(el => el.getAnimations().forEach(animation => animation.cancel()));
          extra.hidden = false; extra.inert = !desired;
          button.setAttribute('aria-expanded', String(desired));
          button.querySelector('[data-scope-toggle-label]').textContent = desired ? board.dataset.scopeLess : board.dataset.scopeMore;
          extra.classList.add('is-transitioning');
          if (!desired && button.getBoundingClientRect().top < 100) {
            window.scrollTo({top:window.scrollY + button.getBoundingClientRect().top - 150, behavior:reduced ? 'instant' : 'smooth'});
          }
          const animations = reveals.map((el, index) => {
            const end = desired ? el.firstElementChild.getBoundingClientRect().height : 0;
            if (reduced) return null;
            const animation = el.animate({height:[heights[index]+'px',end+'px'],opacity:[desired ? 0 : 1,desired ? 1 : 0]}, {duration:480,easing:'cubic-bezier(.22,1,.36,1)',fill:'forwards'});
            this.scopeAnimations.push(animation);return animation;
          }).filter(Boolean);
          await Promise.all(animations.map(animation => animation.finished.catch(() => {})));
          if (currentRevision !== revision || signal.aborted) return;
          extra.hidden = !desired;
          extra.classList.remove('is-transitioning');
          animations.forEach(animation => animation.cancel());
          this.scopeAnimations = this.scopeAnimations.filter(animation => !animations.includes(animation));
          if (desired) {
            const top = extra.getBoundingClientRect().top + window.scrollY - Math.min(window.innerHeight * .35, 240);
            window.scrollTo({top, behavior:reduced ? 'instant' : 'smooth'});
          }
        }, {signal});
      });
      const money = value => new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency:'EUR',maximumFractionDigits:0}).format(value);
      this.observer = new IntersectionObserver(entries => entries.forEach(entry => entry.target.classList.toggle('is-visible', entry.isIntersecting)), {threshold:.12});
      this.querySelectorAll('[data-demo]').forEach(demo => {
        this.observer.observe(demo);
        const on = (selector,event,callback) => demo.querySelectorAll(selector).forEach(el => el.addEventListener(event,callback,{signal}));
        const tabs = (buttons,panels) => on(buttons,'click',event => {
          const selected = event.currentTarget.dataset[Object.keys(event.currentTarget.dataset).find(key => key !== 'demo')];
          demo.querySelectorAll(buttons).forEach((b,index) => b.setAttribute('aria-pressed',String(index === Number(selected))));
          demo.querySelectorAll(panels).forEach((p,index) => p.hidden = index !== Number(selected));
          demo.dataset.interacted = 'true';
        });
        if(demo.dataset.demo === 'development') {
          on('[data-build-device]','click',event=>{
            const device=event.currentTarget.dataset.buildDevice;
            demo.querySelector('[data-build-screen]').classList.toggle('is-mobile',device==='mobile');
            demo.querySelectorAll('[data-build-device]').forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.buildDevice===device)));
          });
          on('[data-build-add]','click',()=>{demo.querySelector('[data-build-count]').textContent='1';demo.querySelector('[data-build-cart]').hidden=false;});
          on('[data-build-reset]','click',()=>{demo.querySelector('[data-build-count]').textContent='0';demo.querySelector('[data-build-cart]').hidden=true;demo.querySelector('[data-build-add]').focus({preventScroll:true});});
          tabs('[data-build-tab]','[data-build-note]');
        }
        if(demo.dataset.demo === 'ecommerce') {
          on('[data-demo-market]','change',event => {
            const market = event.target.value;
            const config = {EU:['EUR',1],US:['USD',1.18],UK:['GBP',.89]}[market];
            if(!config) return;
            demo.querySelectorAll('[data-price]').forEach(el => el.textContent = new Intl.NumberFormat(document.documentElement.lang || 'en',{style:'currency',currency:config[0],maximumFractionDigits:0}).format(Math.round(Number(el.dataset.price)*config[1])));
            demo.querySelectorAll('.bc-demo__products article').forEach((el,index) => el.style.order = String(market === 'US' ? (index+1)%3 : index));
          });
          tabs('[data-ecom-tab]','[data-ecom-note]');
        }
        if(demo.dataset.demo === 'cro') {
          const percent=new Intl.NumberFormat(document.documentElement.lang||'en',{style:'percent',minimumFractionDigits:2,maximumFractionDigits:2});
          demo.querySelectorAll('[data-cro-percent]').forEach(node=>{node.textContent=percent.format(Number(node.dataset.croPercent));});
        }
        if(demo.dataset.demo === 'paid') {
          const update=()=>{
            const discount=Number(demo.querySelector('[data-paid-discount]')?.value ?? 13260);
            const refunds=Number(demo.querySelector('[data-paid-refund]')?.value ?? 8460);
            const media=Number(demo.querySelector('[data-paid-media]')?.value ?? 27300);
            const net=127840-discount-refunds,product=33960,logistics=15300,marketing=media+5840;
            const contribution=net-product-logistics-marketing;
            const set=(selector,value)=>{const el=demo.querySelector(selector);if(el)el.textContent=value;};
            set('[data-paid-net]',money(net));set('[data-paid-contribution]',money(contribution));
            set('[data-paid-discounts]','−'+money(discount));set('[data-paid-refunds]','−'+money(refunds));set('[data-paid-spend]','−'+money(media));
            set('[data-paid-discount-value]',money(discount));set('[data-paid-refund-value]',money(refunds));set('[data-paid-spend-value]',money(media));
            const number=value=>new Intl.NumberFormat(document.documentElement.lang||'en',{minimumFractionDigits:2,maximumFractionDigits:2}).format(value)+'×';
            set('[data-paid-roas]',number(net/media));set('[data-paid-mer]',number(net/marketing));
            set('[data-paid-margin]',new Intl.NumberFormat(document.documentElement.lang||'en',{style:'percent',minimumFractionDigits:1,maximumFractionDigits:1}).format(contribution/net));
            const parts={product,logistics,marketing,contribution:Math.max(0,contribution)};
            const total=Object.values(parts).reduce((a,b)=>a+b,0);
            Object.entries(parts).forEach(([key,value])=>demo.querySelector('[data-paid-segment="'+key+'"]').style.width=(value/total*100)+'%');
            demo.classList.toggle('is-negative',contribution<0);
            const graphic=demo.querySelector('.bc-demo__margin-track');
            graphic.setAttribute('aria-label',demo.querySelector('[data-paid-contribution]').textContent+' · '+demo.querySelector('[data-paid-margin]').textContent);
          };
          on('input[type=range]','input',update);update();
        }
        if(demo.dataset.demo === 'retention') {
          tabs('[data-journey]','[data-journey-panel]');
          if(demo.dataset.context === 'hero' && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
            let current=0;
            this.timers.push(setInterval(() => {
              if(!demo.classList.contains('is-visible') || document.hidden || demo.dataset.interacted || demo.matches(':hover,:focus-within')) return;
              current=(current+1)%4;
              demo.querySelectorAll('[data-journey]').forEach((b,i)=>b.setAttribute('aria-pressed',String(i===current)));
              demo.querySelectorAll('[data-journey-panel]').forEach((p,i)=>p.hidden=i!==current);
            },5000));
          }
        }
        if(demo.dataset.demo === 'seo') tabs('[data-seo-node]','[data-seo-panel]');
        if(demo.dataset.demo === 'data') {
          const paths=['M0 222 35 217 65 224 100 199 140 188 180 195 220 159 260 165 300 125 340 139 380 92 420 102 460 48 500 23','M0 225 35 220 65 210 100 214 140 195 180 182 220 190 260 152 300 147 340 118 380 126 420 86 460 65 500 45','M0 225 35 230 65 219 100 224 140 208 180 218 220 183 260 190 300 159 340 175 380 141 420 145 460 112 500 90'];
          on('[data-data-metric]','click',event => {const i=Number(event.currentTarget.dataset.dataMetric);demo.querySelectorAll('[data-data-metric]').forEach((b,j)=>b.setAttribute('aria-pressed',String(i===j)));demo.querySelector('[data-data-chart]').setAttribute('d',paths[i]);});
          const update=() => {
            const costs=Number(demo.querySelector('[data-data-costs]')?.value || 35); const media=Number(demo.querySelector('[data-data-media]')?.value || 25);const profit=100-costs-media-15;
            [costs,media,15].forEach((v,i)=>{const label=demo.querySelector('[data-cost="'+i+'"]');if(label) label.textContent='−'+money(v*1000);const bar=demo.querySelector('[data-cost-bar="'+i+'"]');if(bar)bar.style.width=v+'%';});
            const label=demo.querySelector('[data-profit]');if(label)label.textContent=money(profit*1000);const bar=demo.querySelector('[data-profit-bar]');if(bar)bar.style.width=profit+'%';
          };
          on('input[type=range]','input',update);update();
        }
      });
    }
    disconnectedCallback() {this.abort?.abort();this.abort=null;this.observer?.disconnect();this.timers?.forEach(clearInterval);this.scopeAnimations?.forEach(animation=>animation.cancel());}
  }
  customElements.define('bc-service-page',ServicePage);
})();
